export default __webpack_public_path__ + "static/media/project2-p3.ec8ed5d6.png";